import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Inicio from "./pages/Inicio";
import CrearUtensilio from "./pages/CrearUtensilio";
import Inventario from "./pages/Inventario";

export default function App() {
  // Lee el estado de sesión desde sessionStorage
  const readSesion = () => !!sessionStorage.getItem("almacenKey");

  const [sesionIniciada, setSesionIniciada] = useState(readSesion);
  const lastValueRef = useRef(readSesion());

  useEffect(() => {
    // 1) Por si usas varias pestañas
    const onStorage = () => {
      const val = readSesion();
      if (val !== lastValueRef.current) {
        lastValueRef.current = val;
        setSesionIniciada(val);
      }
    };
    window.addEventListener("storage", onStorage);

    // 2) Vigilancia proactiva (no hay que tocar otras pantallas)
    const id = setInterval(() => {
      const val = readSesion();
      if (val !== lastValueRef.current) {
        lastValueRef.current = val;
        setSesionIniciada(val);
      }
    }, 400); // cada 400ms

    return () => {
      window.removeEventListener("storage", onStorage);
      clearInterval(id);
    };
  }, []);

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        {/* NAV: sólo visible si hay sesión */}
        {sesionIniciada && (
          <nav className="bg-white/80 backdrop-blur-md shadow-sm py-3">
            <div className="max-w-5xl mx-auto flex justify-center gap-8 text-slate-700 font-medium">
              <Link
                to="/"
                className="hover:text-blue-600 transition-colors duration-200"
              >
                Inicio
              </Link>
              <Link
                to="/crear"
                className="hover:text-blue-600 transition-colors duration-200"
              >
                Crear utensilio
              </Link>
              <Link
                to="/inventario"
                className="hover:text-blue-600 transition-colors duration-200"
              >
                Inventario
              </Link>
            </div>
          </nav>
        )}

        <main className="flex-1 bg-slate-50/40">
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/crear" element={<CrearUtensilio />} />
            <Route path="/inventario" element={<Inventario />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}
